// Recovered compiled webpack factory 77700. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e) {
    return e.replace(/\/$/, "") || "/";
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "removeTrailingSlash", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
}
